export default __webpack_public_path__ + "536744bec59e340dc7ef1aa70965c355.svg";